import React from 'react';
import './PlayerSelector.css';

const PlayerSelector = ({ numPlayers, onIncrease, onDecrease }) => {
    return (
        <div className="player-selector">
            <button onClick={onDecrease} className="player-selector-button">-</button>
            <input
                type="text"
                value={numPlayers}
                readOnly
                className="player-selector-input"
            />
            <button onClick={onIncrease} className="player-selector-button">+</button>
        </div>
    );
};

export default PlayerSelector;
